import client from '../httpClient';

// mokuhyoSet001 params = userId
const mokuhyoSetGetChangeHistryApi = (params) => {
  return client.get(`/target-settings?userId=${params}`);
};

export default mokuhyoSetGetChangeHistryApi;
